import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { AppLocalStorage } from "../app-storage-manager/local-storage";

@Injectable({
    providedIn: 'root'
})
export class HttpService {

    constructor(private http: HttpClient,
        private appLocalStorage: AppLocalStorage) {
    }

    getData(url: string): Observable<any> {
        return this.http.get(url);
    }

    getDataWithHeaders(url: string, params?: any): Observable<any> {
        const headers = new HttpHeaders()
            .set('Authorization', 'Bearer ' + this.appLocalStorage.getAccessToken())
            .set('Content-Type', 'application/json');

        const options = { headers: headers, params: params };
        return this.http.get(url, options);
    }

    postData(url: string, request: any): Observable<any> {
        const headers = new HttpHeaders()
            .set('Authorization', 'Bearer ' + this.appLocalStorage.getAccessToken())
            .set('Content-Type', 'application/json');
        const options = { headers: headers };
        return this.http.post(url, request, options);
    }
}